import { cptQuery } from 'scenes/Gallery/GalleryPage/Concepts/data/queryKeyFactory';

const REVIEWS = 'conceptReviews';

export const reviewsQuery = cptQuery.query(REVIEWS);
export const list = reviewsQuery.grid();
export const mutations = reviewsQuery.mutations();
export const remove = mutations.delete();
export const create = mutations.create();
export const update = mutations.update();
